// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgPhoneAngled: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M21.875 19.934c-.029-.196-.372-.539-1.03-1.026-.176-.148-3.074-2.619-3.21-2.717a1.021 1.021 0 0 0-.422-.186c-.206-.036-.489.065-.85.304-.36.239-.7.508-1.019.809-.199.187-.61.528-.61.528l-.458.34c-.302.204-.538.29-.709.26-.093-.016-1.204-.823-1.223-.837-1.274-1.031-2.349-2.125-3.18-3.313-.832-1.187-1.493-2.573-2.027-4.123a7.885 7.885 0 0 0-.126-.325c-.078-.194-.26-1.018-.243-1.11.03-.169.189-.358.475-.57l.477-.314c.23-.142.469-.275.717-.4.391-.197.76-.424 1.108-.68.349-.258.54-.49.577-.697a1.024 1.024 0 0 0-.03-.459c-.047-.163-1.378-3.73-1.456-3.946a6.448 6.448 0 0 0-.365-.993c-.088-.176-.17-.285-.248-.326a.568.568 0 0 0-.14-.062 1.378 1.378 0 0 0-.176-.042C7.429 0 7.057-.012 6.59.012c-.466.024-.838.07-1.116.137a1.733 1.733 0 0 0-.545.235l-.465.344a7.917 7.917 0 0 0-1.26 1.42c-.522.752-.855 1.53-.996 2.334a5.87 5.87 0 0 0-.09.821 6.8 6.8 0 0 0 .037.924c.035.346.067.604.095.773.029.169.084.474.166.914.082.439.13.707.144.806.183 1.074.451 2.05.806 2.932.581 1.461 1.452 3.02 2.61 4.675a27.678 27.678 0 0 0 1.89 2.42 18.987 18.987 0 0 0 1.782 1.782 14.423 14.423 0 0 0 2.309 1.61c.087.047.323.184.708.411.384.227.652.384.801.468.15.086.382.203.695.355.314.15.599.267.856.35.255.082.523.148.8.197.95.167 1.954.073 3.015-.282a7.874 7.874 0 0 0 1.298-.562l.481-.322a1.82 1.82 0 0 0 .395-.422l.004-.006a6.25 6.25 0 0 0 .508-.996c.182-.43.298-.784.347-1.062a.87.87 0 0 0 .01-.334" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgPhoneAngled);
export default Memo;
